




















































































































































































































































































































































import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { ValidationProvider, ValidationObserver, validate } from 'vee-validate';
import { Options } from '@/models/options.model';
import { routeName } from '@/constants/route.constants';
import { PreferredContactMethodType } from '@/constants/preferred-contact-method-type';
import { PhoneNumberType } from '@/constants/phone-number-type';
import { ValidationResult } from 'vee-validate/dist/types/types';
import VueRecaptcha from 'vue-recaptcha';
import LoadingComponent from '@/components/shared/loading.component.vue';
import CustomerModule, {
  CUSTOMERS_MODULE_NAME
} from '@/store/modules/customer.module';
import RegisteredTagModule, {
  REGISTERED_TAG_MODULE_NAME
} from '@/store/modules/registered-tag.module';
import AuthenticationModule from '@/store/modules/authentication.module';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { mapState } from 'vuex';
import { Customer } from '@/models/DTO/customer/customer.model';
import { BaseAPIErrorModel } from '@/models/DTO/base-api-error.model';
import { CustomerBaseModel } from '@/models/DTO/customer/customer-base.model';
import { RegisteredTag } from '@/models/DTO/registered-tag/registered-tag.model';
import CustomerShowFieldMixin from '@/mixins/customer-show-field.mixin';
import { Role } from '@/constants/role.constants';
import { cid, container } from 'inversify-props';
import { EventLogService } from '@/services/event-log.service';
import { EventLogNames } from '@/constants/event-log-names.constants';
import { RegexConstants } from '@/constants/regex.constants';
import { VETERINARIAN_MODULE_NAME } from '@/store/modules/veterinarian.module';
import ManageTagFormComponent from '@/components/registration/manage-tag-form.component.vue';

const customerModule: CustomerModule = getModule(CustomerModule, store);

const registeredTagModule: RegisteredTagModule = getModule(
  RegisteredTagModule,
  store
);

const authenticationModule: AuthenticationModule = getModule(
  AuthenticationModule,
  store
);

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    VueRecaptcha,
    LoadingComponent,
    ManageTagFormComponent
  },
  computed: {
    ...mapState(CUSTOMERS_MODULE_NAME, [
      'currentCustomer',
      'showButtonLoading',
      'errorResponse'
    ]),
    ...mapState(REGISTERED_TAG_MODULE_NAME, {
      currentRegisteredTag: 'currentRegisteredTag',
      showLoading: 'showLoading',
      showTagButtonLoading: 'showButtonLoading',
      errorTagResponse: 'errorResponse',
      errorLookupResponse: 'errorLookupResponse'
    }),
    ...mapState(VETERINARIAN_MODULE_NAME, ['selectedVeterinarianOfficeId'])
  }
})
export default class CustomerFormComponent extends mixins(
  CustomerShowFieldMixin
) {
  @Prop({
    default: ''
  })
  public title: string;

  public showLoading: boolean;
  public showButtonLoading: boolean;
  public showTagButtonLoading: boolean;
  public currentRegisteredTag: RegisteredTag | null;
  public currentCustomer: Customer | null;
  public errorResponse: BaseAPIErrorModel | null;
  public errorTagResponse: BaseAPIErrorModel | null;
  public errorLookupResponse: BaseAPIErrorModel | null;
  public selectedVeterinarianOfficeId: string;
  public registerLater = false;
  public addingExistingCustomerToNewRegistration = false;
  public firstName = '';
  public lastName = '';
  public email = '';
  public terms = true;
  public selectedPhoneType = '';
  public phone = '';
  public address1 = '';
  public address2 = '';
  public city = '';
  public state = '';
  public zipCode = '';
  public website = '';
  public disabledEmailLookup = true;
  public showEmailSearchLoading = false;

  public get RegexConstants(): RegexConstants {
    return RegexConstants;
  }

  public methodOfContact: Array<Options> = Object.entries(
    PreferredContactMethodType
  ).map(([key, value]) => {
    return {
      text: key,
      value: value
    };
  });

  public phoneType: Array<Options> = Object.entries(PhoneNumberType).map(
    ([key, value]) => {
      return {
        text: key,
        value: value
      };
    }
  );

  @Ref()
  public customerForm!: HTMLFormElement;

  public get disableEmailEditing(): boolean {
    if (this.addingExistingCustomerToNewRegistration || this.currentCustomer) {
      return true;
    }

    if (
      this.currentRegisteredTag &&
      this.currentRegisteredTag.customer &&
      this.page !== this.routeName.veterinarian.addCustomer &&
      this.page !== this.routeName.admin.addCustomer
    ) {
      return true;
    }

    return false;
  }

  public get customerId(): string {
    return this.$route.params.customerId;
  }

  public get code(): string {
    return this.$route.params.tagCode;
  }

  public get routeName(): typeof routeName {
    return routeName;
  }

  public get page(): string | null | undefined {
    return this.$route.name;
  }

  public get role(): typeof Role {
    return Role;
  }

  public get roles(): Array<string> {
    return authenticationModule.jwtRoles;
  }

  public get veterinarianOfficeId(): string {
    return authenticationModule.jwtVeterinarianOfficeId;
  }

  public get veterinarianAdmin(): boolean {
    return authenticationModule.jwtRoles.includes(Role.Veterinarian);
  }

  public get isVeterinarianPage(): boolean {
    if (this.page) {
      return !this.page.includes('public') && !this.page.includes('admin');
    }

    return false;
  }

  @Watch('selectedMethodOfContact')
  private onSelectedMethodOfContactChanged(newVal: string, oldVal: string) {
    if (newVal !== oldVal && oldVal !== '') {
      this.reset();
    }
  }

  @Watch('errorResponse', { deep: true })
  private onErrorResponseChanged(value: BaseAPIErrorModel) {
    if (value) {
      const errors = value.getAllErrorMessages();
      return this.$toasted.error(errors.join());
    }
  }

  @Watch('errorTagResponse', { deep: true })
  private onErrorTagResponseChanged(value: BaseAPIErrorModel) {
    if (value) {
      const errors = value.getAllErrorMessages();
      return this.$toasted.error(errors.join());
    }
  }

  public async created() {
    await customerModule.clearCurrentCustomerAction();
    await registeredTagModule.resetCurrentTagAction();

    if (this.page !== routeName.veterinarian.createRegistration) {
      await registeredTagModule.getTagByCodeAction(this.code);

      if (
        !this.errorResponse &&
        !this.errorTagResponse &&
        this.currentRegisteredTag &&
        this.currentRegisteredTag.customer &&
        this.page !== routeName.veterinarian.addCustomer
      ) {
        this.getCustomerModelForEditing(this.currentRegisteredTag.customer);
      }
    }
  }

  public getCustomerModelForEditing(customer: Customer) {
    if (customer) {
      this.email = customer.email;
      this.firstName = customer.firstName || '';
      this.lastName = customer.lastName || '';
      this.selectedPhoneType = customer.phoneNumberTypeId?.toString() || '';
      this.selectedMethodOfContact =
        customer.preferredContactMethodId.toString() || '';
      this.phone = customer.phoneNumber || '';
      this.address1 = customer.address1 || '';
      this.address2 = customer.address2 || '';
      this.city = customer.city || '';
      this.state = customer.state || '';
      this.zipCode = customer.zipCode || '';
      this.website = customer.website || '';
    }
  }

  public reset() {
    // This only resets validation on the form elements
    // associated with PreferredContactMethodType
    this.customerForm.reset();
  }

  public async onEmailInput(value: string): Promise<void> {
    // Only allow a lookup when the email has been validated
    const result: ValidationResult = await validate(
      this.email,
      'required|email',
      {
        values: {
          value
        }
      }
    );

    if (result.valid) {
      this.disabledEmailLookup = false;
    } else {
      this.addingExistingCustomerToNewRegistration = false;
      this.disabledEmailLookup = true;
    }
  }

  public async onEmailLookupClick(): Promise<void> {
    this.showEmailSearchLoading = true;

    await customerModule.getCustomerByEmailAction(this.email);

    if (!this.errorLookupResponse && this.currentCustomer) {
      this.addingExistingCustomerToNewRegistration = true;
      this.getCustomerModelForEditing(this.currentCustomer);
    } else {
      this.$toasted.error('No information was found for this email address.');
    }

    this.showEmailSearchLoading = false;
  }

  public setCustomerBaseModelForSaving(): CustomerBaseModel {
    const methodId = Object.values(PreferredContactMethodType).find(
      (type) => type === this.selectedMethodOfContact
    );

    const model: CustomerBaseModel = {
      firstName: this.firstName || null,
      lastName: this.lastName || null,
      preferredContactMethodId: methodId || PreferredContactMethodType.Call, // Call will be a fallback
      email: this.email
    };

    if (methodId === PreferredContactMethodType.Address) {
      model.address1 = this.address1 || null;
      model.address2 = this.address2 || null;
      model.city = this.city || null;
      model.state = this.state || null;
      model.zipCode = this.zipCode || null;
    } else if (methodId === PreferredContactMethodType.Call) {
      model.phoneNumber = this.phone || null;
      model.phoneNumberTypeId = PhoneNumberType.Mobile;
    } else if (methodId === PreferredContactMethodType.Text) {
      model.phoneNumber = this.phone || null;
      model.phoneNumberTypeId = PhoneNumberType.Mobile;
    } else if (methodId === PreferredContactMethodType.Website) {
      model.website = this.website || null;
    }

    return model;
  }

  public onSaveClick() {
    const model = this.setCustomerBaseModelForSaving();

    if (!this.customerId && !this.addingExistingCustomerToNewRegistration) {
      this.registerCustomer(model);
    } else {
      this.updateCustomer(model);
    }
  }

  public async registerCustomer(customer: CustomerBaseModel): Promise<void> {
    if (this.page === routeName.veterinarian.createRegistration) {
      this.registerLater = false;

      await registeredTagModule.addNewTagAction({
        code: this.code,
        veterinarianOfficeId: this.veterinarianOfficeId
      });
    }

    if (!this.errorTagResponse && this.currentRegisteredTag) {
      await customerModule.registerCustomerIfNeededAction(customer);

      if (!this.errorResponse && this.currentCustomer) {
        // update tag registration with customer id
        await registeredTagModule.updateTagAction({
          ...this.currentRegisteredTag,
          id: this.currentRegisteredTag.id || '',
          customerId: this.currentCustomer?.id
        });

        if (!this.errorResponse && !this.errorTagResponse) {
          this.$toasted.success('Customer successfully registered.');
          this.navigateOut();
        }
      }
    }
  }

  public async updateCustomer(customer: CustomerBaseModel): Promise<void> {
    if (this.page === routeName.veterinarian.createRegistration) {
      this.registerLater = false;

      await registeredTagModule.addNewTagAction({
        code: this.code,
        veterinarianOfficeId: this.veterinarianOfficeId
      });
    }

    if (!this.errorTagResponse && this.currentRegisteredTag) {
      // update customer info
      await customerModule.updateCustomerAction({
        id: this.customerId || this.currentCustomer?.id,
        ...customer
      });

      if (
        !this.errorResponse &&
        this.currentCustomer &&
        this.addingExistingCustomerToNewRegistration
      ) {
        // update tag registration with customer id
        await registeredTagModule.updateTagAction({
          ...this.currentRegisteredTag,
          id: this.currentRegisteredTag.id || '',
          customerId: this.currentCustomer?.id
        });
      }

      if (!this.errorResponse && !this.errorTagResponse) {
        this.$toasted.success('Customer updated successfully.');
        this.navigateOut();
      }
    }
  }

  public navigateOut() {
    // let this continue without waiting
    registeredTagModule.getAllTagsByVeterinarianOfficeIdAction(
      this.veterinarianOfficeId || this.selectedVeterinarianOfficeId
    );

    if (
      this.page === routeName.admin.editCustomer ||
      this.page === routeName.admin.addCustomer ||
      this.page === routeName.admin.createCustomer
    ) {
      this.$router.push({ name: routeName.admin.registrations });
    } else {
      if (this.page === routeName.veterinarian.createRegistration) {
        this.$router.push({ name: routeName.veterinarian.register });
      } else {
        this.$router.push({ name: routeName.veterinarian.registrations });
      }
    }
  }

  public resetFormFields() {
    this.email = '';
    this.firstName = '';
    this.lastName = '';
    this.selectedPhoneType = '';
    this.selectedMethodOfContact = '';
    this.phone = '';
    this.address1 = '';
    this.address2 = '';
    this.city = '';
    this.state = '';
    this.zipCode = '';
    this.website = '';

    this.customerForm.reset();
  }

  public onChangeOwnershipClick() {
    this.resetFormFields();

    this.$toasted.info(
      `Caution: By saving you will update the registration for ${this.code} with a new owner.`,
      {
        duration: 7000,
        fullWidth: true,
        fitToScreen: true,
        className: ['bg-warning', 'text-dark']
      }
    );

    this.$router.replace({
      name: this.roles.includes(Role.Admin)
        ? routeName.admin.addCustomer
        : routeName.veterinarian.addCustomer,
      params: {
        tagCode: this.code
      }
    });
  }

  public async onClearResultsClick() {
    await customerModule.clearCurrentCustomerAction();
    this.addingExistingCustomerToNewRegistration = false;
    this.disabledEmailLookup = true;
    this.resetFormFields();
  }

  public async onCompleteLaterClick() {
    this.registerLater = true;

    await registeredTagModule.addNewTagAction({
      code: this.code,
      veterinarianOfficeId: this.veterinarianOfficeId
    });

    if (!this.errorTagResponse) {
      this.navigateOut();
    }
  }

  public async onShowCompleteLaterConfirmDialog() {
    // log click event
    const eventLogService = container.get<EventLogService>(cid.EventLogService);
    await eventLogService.logEvent({
      eventName: EventLogNames.completeLaterButtonClick
    });

    const value = await this.$bvModal.msgBoxConfirm(
      'STOP! Any customer information you have entered will be lost. CONTINUE after you have noted the label ID # and customer info to enter later. CANCEL to complete the registration now.',
      {
        title: 'Please Confirm',
        okVariant: 'danger',
        okTitle: 'Confirm',
        cancelTitle: 'Cancel'
      }
    );

    if (value) {
      await this.onCompleteLaterClick();
    }
  }

  public onEditTagClick() {
    this.$bvModal.show('modal-manage-tag');
  }

  public onCompletionHandler(newTagCode: string) {
    this.$bvModal.hide('modal-manage-tag');

    // No need to await this call
    registeredTagModule.getAllTagsByVeterinarianOfficeIdAction(
      this.selectedVeterinarianOfficeId
    );

    this.$router.replace({
      name: this.roles.includes(this.role.Admin)
        ? routeName.admin.editCustomer
        : routeName.veterinarian.editCustomer,
      params: {
        tagCode: newTagCode,
        customerId: this.customerId
      }
    });
  }
}
